import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/styled-system'
import { textStyleKeys } from '~/themes/textStyles'
import { textStyles } from '~/themes/textStyles/defaultTextStyles'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

export enum PopoverToastVariants {
  Success = 'success',
  Failure = 'failure',
  Info = 'info',
}

const popoverToastParts = ['container', 'text'] as const

const helpers = createMultiStyleConfigHelpers(popoverToastParts)

export const PopoverToastStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      justifyContent: 'center',
      alignItems: 'center',
      width: 'fit-content',
      height: '2.5rem',
      padding: '0.75rem',
      borderRadius: '.5rem',
      border: '1px solid',
      borderLeft: '3px solid',
      '@keyframes opacity': {
        '0%, 100%': {
          opacity: 0,
        },
        '25%': {
          opacity: 1,
        },
      },
    },
    text: {
      ...textStyles[textStyleKeys.Body2],
    },
  },
  variants: {
    [PopoverToastVariants.Success]: {
      container: {
        background: 'green.200',
        borderColor: 'green.800',
      },
      text: {
        color: 'green.900',
      },
    },
    [PopoverToastVariants.Failure]: {
      container: {
        background: 'red.100',
        borderColor: 'red.800',
      },
      text: {
        color: 'red.900',
      },
    },
    [PopoverToastVariants.Info]: {
      container: {
        background: 'blue.100',
        borderColor: 'blue.800',
      },
      text: {
        color: 'blue.900',
      },
    },
  },
})

export const usePopoverToastStyles = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof popoverToastParts>(
    getName({ PopoverToastStyle }),
    props,
  )
}
